import React from 'react'
import { useEffect } from 'react';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import { useState } from 'react';
import Headline from '../../../components/headline/Headline';
import { Token, get, post } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Userdisplay from '../../../components/userdisplay/Userdisplay';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Input, Link, Table, Typography } from '@mui/joy';
import { haspermission } from '../../../Script/Permission';

const Nutzerdateien = () => {
    const navigate = useNavigate();
    const [wit, setwith] = useState("90.5%");
    const [data, setdata] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [perm, setperm] = useState(haspermission("18"));

    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "getuser";
        let response = post(body, "/vereinsuserdata/text");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response).result);
    }, []);
    if (!perm) {
        return (
            <>
                <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                    <p style={{ color: "red" }}>Keine Berechtigung!</p>
                </div>
                <NavigationBar state={"verein"} back={true} />

            </>

        )

    }


    return (
        <>
            <head><title>Verein || Nutzer Dateien</title></head>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                <Headline title={"NutzerDateien"} />
                <Box sx={{ height: "100%", width: "100%", alignItems: "center", display: "flex", flexDirection: "column" }}>
                    <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 3, mt: 8 }}>
                        <Input
                            placeholder="Suche..."
                            startDecorator={<SearchIcon />}
                            value={searchTerm}
                            onChange={(e) => {setSearchTerm(e.target.value); setDebouncedSearchTerm(e.target.value)}}
                            sx={{ width: 500 }}
                        />
                    </Box>
                    <Table sx={{ width: "98.5%" }}>
                        <thead>
                            <tr>
                                <th>Vor/Nachname</th>
                                <th>E-MAIL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data
                                    ?.filter(item => item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
                                    .map((item => {
                                        return (
                                            <tr key={item.id}>
                                                <td><Link href={window.location.origin + "/view_uservereinsdata/" + item.id + "/" + item.name}>{item.name}</Link></td>
                                                <td><Link href={window.location.origin + "/view_uservereinsdata/" + item.id + "/" + item.name}>{item.email}</Link></td>
                                            </tr>
                                        )
                                    }))
                            }


                        </tbody>
                    </Table>
                </Box>
            </div>
            <NavigationBar state={"verein"} back={true} />
        </>
    )
}

export default Nutzerdateien

